import type {Column} from 'components/DSYS/Table';

export function getTableWidthPx<T>(columns: Column<T>[]): number {
  return columns.reduce((sum, column) => {
    if (typeof column.width === 'number') {
      return sum + column.width;
    }
    if (typeof column.minWidth === 'number') {
      return sum + column.minWidth;
    }
    return sum;
  }, 0);
}
